import { useRagnar } from '@mentimeter/ragnar-react';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { GuessTheNumber } from '@mentimeter/visualizations-react/visualizations/guess-the-number';

interface GuessTheNumberVisualizationProps {
  responseRangeMin: number;
  responseRangeMax: number;
  responseRangeScale: number;
  correctAnswerRange: {
    min: number;
    max: number;
  };
  results: { [id: number]: number };
  shouldShowCorrect: boolean;
  shouldAnimate: boolean;
}

export const GuessTheNumberVisualization = ({
  responseRangeMin,
  responseRangeMax,
  responseRangeScale,
  correctAnswerRange,
  results,
  shouldShowCorrect,
  shouldAnimate,
}: GuessTheNumberVisualizationProps) => {
  const {
    theme: {
      colors: { bg },
      visualizationColors,
      fonts: { body },
    },
  } = useRagnar();

  // Correct answer is the middle of the correct answer range, rounded to the nearest integer
  const correctAnswer = Math.round(
    correctAnswerRange.min +
      (correctAnswerRange.max - correctAnswerRange.min) / 2,
  );

  const isCorrectAnswerRangeSameAsCorrectAnswer =
    correctAnswerRange.min === correctAnswerRange.max;

  return (
    <FullSizeContainer>
      {(width, height) => (
        <GuessTheNumber
          width={width}
          height={height}
          rangeMax={responseRangeMax}
          rangeMin={responseRangeMin}
          data={results}
          correctAnswer={{
            correctValue: correctAnswer,
            range: isCorrectAnswerRangeSameAsCorrectAnswer
              ? undefined
              : correctAnswerRange,
          }}
          shouldShowCorrectAnswer={shouldShowCorrect}
          fontFamily={body}
          responseRangeScale={responseRangeScale}
          colors={visualizationColors.fillColors as [string, ...string[]]}
          textColor={visualizationColors.textColor}
          backgroundColor={bg}
          disableAnimations={!shouldAnimate}
        />
      )}
    </FullSizeContainer>
  );
};
